/**
 * Page autonome des prérequis Octopus, ouverte depuis l'e-mail (route /prerequis/:token).
 * `?confirm=1` (bouton « J'ai terminé les 2 étapes » de l'e-mail) coche les 2 étapes.
 */
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import OctopusPrerequisSteps from '@/components/OctopusPrerequisSteps';

const API = process.env.REACT_APP_BACKEND_URL;

export default function OctopusPrerequisPage() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const confirmAll = async () => {
      if (params.get('confirm') === '1') {
        try {
          await fetch(`${API}/api/octopus-prerequis/${token}/declare`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ step: 'all' }),
          });
        } catch { /* on affiche la page quoi qu'il arrive */ }
      }
      setReady(true);
    };
    confirmAll();
  }, [token, params]);

  return (
    <div className="force-light min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-8 px-4">
      <div className="max-w-lg mx-auto" data-testid="prerequis-page">
        <div className="text-center mb-6">
          <img src="/o-prime-logo.svg" alt="O Prime Energy" className="h-14 mx-auto mb-4"
            onError={(e) => { e.target.style.display = 'none'; }} />
          <h1 className="text-2xl font-bold text-gray-900">Vos 2 dernières étapes</h1>
          <p className="text-gray-500 text-sm mt-1">
            À valider avant de démarrer sur le terrain.
          </p>
        </div>
        {ready && <OctopusPrerequisSteps token={token} />}
      </div>
    </div>
  );
}
